'use client';
import { useState } from 'react';

/* TODO: при повторной необходимости использовать - обобщить и вынести в hooks */ const useIMESessionGuard = ()=>{
    const [IMESession, setIMESession] = useState(false);
    const startIMESession = ()=>setIMESession(true);
    const endIMESession = ()=>setIMESession(false);
    function guard(handler) {
        return (...args)=>{
            if (IMESession) {
                return;
            }
            return handler(...args);
        };
    }
    return [
        guard,
        startIMESession,
        endIMESession
    ];
};

export { useIMESessionGuard };
//# sourceMappingURL=useIMESessionGuard.js.map
